import { Injectable } from '@angular/core';
import { CapHeaderService } from '@cap/cap-ui';

@Injectable()
export class ConstantService {

	constructor(private capHeaderService: CapHeaderService) { }

	// FOR GET USER INFO.
	getUserInfo = () => {
		return this.capHeaderService.getUserInfo();
	}

	// FOR COMMITTEE MEMBER PERMISSISON
	getCommitteeMemberPermision = () => {
		const userData: any = this.getUserInfo();
		return userData ? userData.isCommitteeMember : null;
	}

	// FOR CAP STAFF PERMISSION.
	getCAPStaffPermision = () => {
		const userData: any = this.getUserInfo();
		return userData ? userData.isCAPStaff : null;
	}

	getDesktopPageSizeOption = length => {
		return [5, 10, 15, 25, length];
	}
}